import styled from "styled-components";
import { FormControl, Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th {
        text-align: center;
        background-color: rgb(221, 221, 221);
        border: 1px solid white !important;
    }

    thead th:first-child {
        border-radius: 4px 0 0 0px;
    }

    thead th:last-child { 
        border-radius: 0 4px 0px 0;
    }

    & > tbody > tr:first-child > td,
    & > tbody > tr:first-child > th {
        border-top: none;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td:first-child {
        // text-align: left;
    }
`;

export const SearchTableWrapper = styled(TableWrapper)`
    & > thead > tr > th {
        font-size: 12px;
        border: 1px solid white !important;
    }

    & > tbody > tr > td {
        font-size: 12px;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    & > div {
        text-align: center;
    }
`;

export const AmountWrapper = styled(FormControl)`
    text-align: center;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 70vh;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #FFF;
    border-radius: 4px;
`;

export const ConfirmTableWrapper = styled(Table)`
    & > tbody > tr > th {
        width: 25%;
        background-color: #eee;
        text-align: right;
    }

    & > tbody > tr > td {
        padding-left: 20px;
    }
`;
